import React from 'react';

function Quiz() {
  return (
    <div>
      <h2>Quiz Page (Coming Soon)</h2>
    </div>
  );
}

export default Quiz;
